//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import config from '@/config/index'
import { getNewslist } from '@/api/youzheng'
export default {
  data () {
    return {
      newsList: [],
      pageCurrent: 1,
      moremsg: '点击加载更多',
      nomore: false,
      baseUrl: config.baseUrl
    }
  },
  computed: {
  },
  mounted () {
    this.getNews()
  },
  methods: {
    getNews () {
      getNewslist({
        pageCurrent: this.pageCurrent,
        pageSize: 8,
        CATEGORYCODE: 'cat13_01',
        owner_type: config.owner_type,
        searchValue: '',
        docterPanduan: 2
      }).then(res => {
        if (res.obj.length > 0) {
          this.newsList = [...this.newsList, ...res.obj]
          this.moremsg = '点击加载更多'
        } else {
          this.moremsg = '没有更多了~'
          this.nomore = true
        }
      })
    },
    detail (link) {
      window.location.href = link
    },
    loadmore () {
      if (!this.nomore) {
        this.moremsg = '正在加载中...'
        this.pageCurrent++
        this.getNews()
      }
    }
  }
}
